import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { API_ENDPOINTS } from '@typings/api-endpoints.type';
import { map, Observable, of } from 'rxjs';
import { GetNotificationResponse } from '../../domain/entities/notifications.entities';
import { SuperAdminHomeServices } from '../../domain/services/superadmin-home.service';
import { buildQueryParams } from '@utils/query';
import { ApiQueryParams } from '@utils/api-query-params.type';

@Injectable()
export class superAdminHomeServicesImpl implements SuperAdminHomeServices {
  constructor(private client: HttpClient) {}
  getNotifications(query: ApiQueryParams): Observable<GetNotificationResponse> {
    const params = buildQueryParams(query);

    return this.client
      .get<GetNotificationResponse>(
        environment.apiDomain + API_ENDPOINTS.NOTIFICATIONS.GET_ALL(),
        { params }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  getAllCustomers(): Observable<number> {
    return this.client
      .get<number>(environment.apiDomain + API_ENDPOINTS.CUSTOMER.COUNT())
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  getAllActiveUsers(): Observable<number> {
    const params = new HttpParams().set('isActive', 'true');
    // // .set('_parentCompanyId', companyId);

    return this.client
      .get<number>(environment.apiDomain + API_ENDPOINTS.USERS.COUNT(), {
        params,
      })

      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  deleteCompany(companyId: string): Observable<any> {
    return this.client
      .delete<any>(
        environment.apiDomain + API_ENDPOINTS.COMPANY.DELETE(companyId)
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  markAsReadNotification(
    notificationId: string
  ): Observable<GetNotificationResponse> {
    return this.client
      .patch<GetNotificationResponse>(
        environment.apiDomain +
          API_ENDPOINTS.NOTIFICATIONS.MARK_AS_READ(notificationId),
        {}
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
    // return of({
    //   data: [
    //     {
    //       message: 'Success',
    //     },
    //   ],
    // });
  }
  getNotificationsCount(query: ApiQueryParams): Observable<{ data: number }> {
    const params = buildQueryParams(query);

    return this.client
      .get<{ data: number }>(
        environment.apiDomain + API_ENDPOINTS.NOTIFICATIONS.COUNT(),
        { params }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
}
